// Centralized tooltip messages
// Edit messages here and they'll update across the app

export const TOOLTIPS: Record<string, string> = {
  // Navbar actions
  "navbar.button.collapse": "Collapse sidebar",
  "navbar.button.expand": "Expand sidebar",
  "data-scope-configurator.metric_selection.tooltip": "Choose which metrics the analyst can access",
  "data-scope-configurator.scope_related_entities.tooltip": "Select related metric entities that the analyst can access",
  "data-scope-configurator.attribute_values.tooltip": "Define specific attribute filters and constraints to further refine the analyst's data access",
  "data-scope-configurator.usage_guidelines.tooltip": "Enter guidelines or instructions for using this data scope",
  "data-scope-configurator.edit_filter_values.tooltip": "Edit filter values",
  "data-scope-configurator.show_filter.tooltip": "Show to analyst",
  "data-scope-configurator.hide_filter.tooltip": "Hide from analyst",
  "data-scope-configurator.remove_filter.tooltip": "Remove filter",
  "preset_filter.constraints.tooltip": "Define constraints for a scenario",
  "scenario_creation_component.details.tooltip": "Enter a brief description of the scenario",
  "scenario_creation_component.details.issue.tooltip": "Enter a brief description of the issue",
  "scenario_creation_component.details.trigger_conditions.tooltip": "Enter a brief description of the trigger conditions",
  "scenario_creation_component.details.investigation_protocol.tooltip": "Enter a brief description of the investigation protocol",
  "scenario_creation_component.details.reporting_instructions.tooltip": "Enter a brief description of the reporting instructions",
  "scenario_creation_component.details.analysis_instructions.tooltip": "Enter a brief description of the analysis instructions",
};


/**
 * Action verbs for the chat artifacts.
 */
export const CHAT_ACTION_VERBS = {
  analyzed: ["Analyzed", "Examined", "Reviewed", "Explored", "Studied"],
  queried: ["Queried", "Retrieved", "Fetched", "Loaded"],
  generated: ["Generated", "Created", "Produced", "Built"],
};

// Welcome chat messages
export const WELCOME_CHAT_MESSAGES = [
  "What's on the agenda today?",
  "What's on your mind today?",
  "Where should we begin?",
  "What can I help with?",
  "Ready when you are."
];
